module.exports = __webpack_public_path__ + "media/images/shapes/waves/wave-1-81de35cd8c9698a246ef4523abef7daa87f1518ee613a823ad965c377ae3a011.svg";